export interface IShippingInformation {
  IsRegisteredUser: boolean;
  Country: string;
  FirstName: string;
  LastName: string;
  StreetPO: string;
  Building: string;
  City: string;
  State: string;
  PostalCode: string;
  PhoneNumber: string;
}

export const ShippingInformationForRegisteredUser: IShippingInformation = {
  IsRegisteredUser: true,
  Country: 'United States of America',
  FirstName: 'John',
  LastName: 'Doe',
  StreetPO: '123 St',
  Building: 'Unit #12',
  City: 'Washington',
  State: 'DC',
  PostalCode: '12345',
  PhoneNumber: '703-654-4859',
};

export default ShippingInformationForRegisteredUser;
